import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/charts/styles.css";
import "mantine-datatable/styles.layer.css";

import { MantineProvider, createTheme } from "@mantine/core";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);

const theme = createTheme({
  primaryColor: "telia",
  primaryShade: { light: 5, dark: 5 },
  colors: {
    telia: [
      "#f8e7ff",
      "#dfbbfa",
      "#c78ef1",
      "#af63ea",
      "#9836e3",
      "#9a39e3",
      "#63159d",
      "#470e72",
      "#2b0746",
      "#11011c",
    ],
  },
});
root.render(
  <React.StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="light">
      <BrowserRouter>
        <b2b-serviceweb-banner
          app-id="SEVONE"
          app-name="Trafikstatistik datakom (f.d. WOVStat)"
          language="sv"
        ></b2b-serviceweb-banner>
        <App />
      </BrowserRouter>
    </MantineProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
